export default __webpack_public_path__ + "static/media/shop_hot_1.1d7368fb.png";